import React, { FunctionComponent } from 'react';
import { IBindingCallback1 } from '../../common/models/callback';
import { ReactComponent as Plus } from '../../assets/icons/plus.svg';
import { ReactComponent as Minus } from '../../assets/icons/minus.svg';
import IconButton from '../IconButton';
import styles from './styles.module.scss';

interface IProps {
  value: number;
  onChange: IBindingCallback1<number>;
  disableMinus?: boolean;
  disablePlus?: boolean;
  textColor?: string;
}

const Counter: FunctionComponent<IProps> = ({
  value,
  onChange,
  disableMinus,
  disablePlus,
  textColor
}) => (
  <div className={`${styles.counter}`}>
    <IconButton
      disabled={value === 0 || disableMinus}
      variant="bordered"
      onClick={() => onChange(value - 1)}
      icon={<Minus />}
      size="lg"
    />
    <div
      style={(value > 0 && textColor) ? { color: textColor } : undefined}
      className={styles.counterText}
    >
      {value}
    </div>
    <IconButton
      disabled={disablePlus}
      variant="bordered"
      onClick={() => onChange(value + 1)}
      icon={<Plus />}
      size="lg"
    />
  </div>
);

export default Counter;
